import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function CTASection() {
  return (
    <section
      data-testid="cta-section"
      className="relative bg-[#1E3A8A] text-white overflow-hidden"
    >
      <div className="grain absolute inset-0" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-8">
            <p className="font-mono-axis text-xs uppercase tracking-widest text-white/70 mb-4">
              /07 · Chamada para ação
            </p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-6xl tracking-tighter font-semibold leading-[1.05]">
              Solicite uma <span className="italic">demonstração</span> gratuita.
            </h2>
            <p className="mt-6 text-base md:text-lg text-white/80 max-w-2xl leading-relaxed">
              Conheça em 30 minutos como a Áxis pode transformar a operação da
              sua instituição de saúde. Sem compromisso, com casos reais.
            </p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <Link
              to="/contato"
              data-testid="cta-demo-button"
              className="group inline-flex items-center gap-3 px-8 py-5 bg-white text-[#1E3A8A] text-base font-medium hover:bg-[#111827] hover:text-white transition-colors"
            >
              Agendar demonstração
              <ArrowUpRight className="w-5 h-5 transition-transform group-hover:rotate-45" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
